export type ActionData = {
    recId: string,
    sku: string,
    productName: string,
    solution: string,
    groupedTVDOpportunity: TvdEroiDto,
    groupedSalesOpportunity: number,
    currentLocations: ActionLocationInfo[],
    previousLocations : ActionLocationInfo[],
    groupedDifficultyScale: number,
    recState: ActionStateInfo,
    actionNotes: ActionNote[],
}

export type ActionLocationInfo = {
    key: string,
    accountNumber: string,
    accountName: string,
    street: string,
    city: string,
    state: string,
    zip: string,
    country: string,
    reasonSolution: string,
    reasonProducts: string
}

//gets passed to 'update' endpoint
export type ActionLocationIdentifier = {
    key:string,
    accountNumber:string
}

export type TvdEroiDto = {
    totalAir: number;
    totalRepair: number;
    totalProductivity: number;
    totalProductivityDollars: number;
    totalReplacement: number;
    totalEnergy: number;
    totalEnergyDollars: number;
    totalPlasticWaste: number;
    totalPlasticWasteDollars: number;
    totalWater: number;
    totalWaterDollars: number;
    totalValueDeliveredDollars: number;
    totalCardboardWaste: number;
    totalCardboardWasteDollars: number;
    totalEmployeeSafety: number;
    totalPortfolioReduction: number;
    totalPortfolioReductionDollars: number;
    totalCostAvoidance: number;
    totalSales: number;
};

export type ActionStateInfo = {
    recommendationState: ActionState,
    recommendationStatus: ActionStatus,
    snoozeDate: string,
    snoozeDuration: number,
    startDate: string,
    endDate: string,
    dismissReason: string
}

export type ActionNote = {
    noteDate: string,
    noteContents: string
}

export type TVDOpportunityModel = {
    "Productivity": string,
    "Assets": string,
    "Employee Safety": string,
    "Water": string,
    "Energy": string,
    "Greenhouse Gases": string,
    "Plastic Waste": string,
    "Cardboard Waste": string,
    "Cost Avoidance": string
}

export type ACUpdateRequest = {
    recId: string,
    state: ActionStateInfo,
    locationIds: ActionLocationIdentifier[],
    solution:string,
    productName:string,
}

export enum ActionState {
    Recommended = "Recommended",
    MyActions = "My Actions",
    Completed = "Completed",
    Dismissed = "Dismissed",
    Snoozed = "Snoozed",
    None = "None" // Using "None" instead of null for better type safety
}

export enum ActionStatus {
    NoActionYet = "No Action Yet",
    PitchedToCustomer = "Pitched to Customer",
    CustomerAccepted = "Customer Accepted",
    EnteredInESS = "Entered in ES&S",
    ActionInProgress = "Action in Progress",
    Completed = "Completed",
    None = "None" // Using "None" instead of null for better type safety
}

export type ActionProductParticipation = {
    productName: string,
    productSKU: string,
    solution: string
}